import { render, staticRenderFns } from "./DeliveryDataArrange.vue?vue&type=template&id=222da407&scoped=true"
import script from "./DeliveryDataArrange.vue?vue&type=script&lang=js"
export * from "./DeliveryDataArrange.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDataArrange.vue?vue&type=style&index=0&id=222da407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222da407",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBanner,VBreadcrumbs,VBreadcrumbsItem,VBtn,VCard,VCheckbox,VList,VListItem,VProgressLinear,VSpacer,VTextField,VTreeview})
